import React, { Component } from "react";
import Loading from "../../../Elements/loading";
import CurrencyService from "../../../Services/CurrencyService";
import { Paper } from '@mui/material';
import JsxHelper from "../../../Helpers/JsxHelper";
import ErrorMessage from "../../../Elements/ErrorMessage";

class CurrencyDetailsPanel extends Component 
{
  constructor(props) 
  {
    super(props);

    this.state = {
      CurrencyId: props.CurrencyId,
      loading: true,
      convertedResult: [],
    };
  }

  componentDidMount() 
  {
    this.GetData();
  }

  renderCell(width, label, datafield) 
  {
    let data = this.state.convertedResult[datafield];

    if (typeof data === "boolean")
      data = JsxHelper.YesNo(data);

    return (
      <div className={width + " "}>
        <div className="container border rounded  hover m-1 p-1">
          <div className="row">
            <div className="col-6">{label}</div>
            <div className="col-6">{data}</div>
          </div>
        </div>
      </div>
    );
  }

  async GetData () 
  {
    this.setState({ loading: true });
    CurrencyService.GetGlobalDataCurrencies(this.props.CurrencyId)
    .then((result) =>
    {
      const convertedResult = CurrencyService.ConvertDBDetails(result);
      this.setState({ convertedResult, loading: false });
    })
    .catch(() => ErrorMessage.SetErrorMessage("CDP54"));
  }

  render() 
  {
    return (
      <div className="">
        <div>{this.renderView()}</div>
      </div>
    );
  }

  renderView() 
  {

    if (this.state.loading === true)
      return <Loading />;

    return (
      <Paper elevation={6} className="border p-1 m-1">
        <div className="container-fluid">
          <div className="row">
            {this.renderCell("col-6", "Description", "Description")}
            {this.renderCell("col-6", "Status", "IsActive")}
            {this.renderCell("col-6", "Symbol", "Symbol")}
            {this.renderCell("col-6", "Code", "Code")}
            {this.renderCell("col-6", "To EUR Rate", "ToEURRate")}
            {this.renderCell("col-6", "From EUR Rate", "ToEurInverseRate")}
            {this.renderCell("col-6", "To USD Rate", "Rate")}
            {this.renderCell("col-6", "From USD Rate", "InverseRate")}
          </div>
          <div>
            <b> Average Rates (USD)</b>
          </div>
          <div className="row">
            {this.renderCell("col-6", "Last 30 Days Rate", "ThirtyDayRate")}
            {this.renderCell("col-6", "Last 30 Days Inverse Rate", "ThirtyDayInverseRate")}
            {this.renderCell("col-6", "Last 90 Days Rate", "NinetyDayRate")}
            {this.renderCell("col-6", "Last 90 Days Inverse Rate", "NinetyDayInverseRate")}
            {this.renderCell("col-6", "Month To Date Rate", "MonthToDateRate")}
            {this.renderCell("col-6", "Month To Date Inverse Rate", "MonthToDateInverseRate")}
            {this.renderCell("col-6", "Year To Date Rate", "YearToDateRate")}
            {this.renderCell("col-6", "Year To Date Inverse Rate", "YearToDateInverseRate")}
          </div>
        </div>
      </Paper>
    );
  }
}

export default CurrencyDetailsPanel;